module.exports = __webpack_public_path__ + "img/linkedin.7b88bcf1.svg";